const sectionTitleReducer = (state = {
    title: 'title',
    subTitle: 'subtitle',
    image: 'place image here'
}, action) => {
    switch(action.type){
        case 'UPDATE_TITLE':
            return{
                ...state,
                ...action.payload
            }
        default:
            return {
                ...state
            };
    }
}

export default sectionTitleReducer;


// WEBPACK FOOTER //
// ./src/SectionTitle/reducers.js